
import { useState, useEffect } from 'react';

import API from 'service/api';
import Util, { padZero } from 'service/util';
import Loading from 'component/Loading';
import Protected from 'component/Protected';
import PopMessage from 'component/pop-msg/PopMessage';
import DatePicker from 'react-datepicker';

const PaymentCard = ({payment}) =>
{
  const [is_loading, setLoading  ] = useState(false)

  const [img_src,    setImgSrc   ] = useState('')
  const [img_width,  setImgWidth ] = useState(0)
  const [img_height, setImgHeight] = useState(0)

  const [payment_type, setPayType]      = useState(payment.payment_type)
  const [transfer_dtm, setTransferDate] = useState(
    payment.transfer_dtm ? new Date(payment.transfer_dtm) : null
  )
  const [ref_code,       setRefCode      ] = useState(payment.ref_code)
  const [remarks,        setRemarks      ] = useState(payment.remarks)
  const [is_skipreceipt, setIsSkipReceipt] = useState(payment.is_skipreceipt)

  useEffect(() => {
    if (!payment) {
      setImgSrc(null)
      return
    }
    API.getPaymentReceiptInfo(payment).then(o =>
    {
      // replace default image for records without image
      if (!o.payment_src) o.payment_src = '/assets/img/res/no-image.jpg'
      // get image size
      let img = new Image()
      img.src = o.payment_src
      img.onload = () => {
        setImgWidth( img.naturalWidth )
        setImgHeight( img.naturalHeight )
        setImgSrc( o.payment_src )
      }
    });
  }, [payment])

  const updatePayment = () => {
    let { ix_yrmo, uid, useq } = payment
    let dto = {
       ix_yrmo, uid, useq
      ,transfer_dtm
      ,payment_type
      ,ref_code
      ,remarks
      ,is_skipreceipt
    }

    setLoading(true)
    API.editPayment(dto).then(resp => {
      if (!resp.success) {
        PopMessage.show('操作失敗。', '失敗', 'danger')
      } else {
        PopMessage.show('已更改紀錄。', '成功', 'success')
        window.location.reload()
      }
      setLoading(false)
    });
  }

  const cancelPayment = () => {
    let { ix_yrmo, uid, useq } = payment
    let dto = { ix_yrmo, uid, useq }
    setLoading(true)
    API.deletePayment(dto).then(resp => {
      if (!resp.success) {
        PopMessage.show('操作失敗。', '失敗', 'danger')
      } else {
        PopMessage.show('已撤消紀錄。', '成功', 'success')
        window.location.reload()
      }
      setLoading(false)
    });
  }

  if (!payment) return ''

  const payment_id = `${payment.company}IV-${payment.ix_yrmo}-${padZero(payment.uid, 7)}-${padZero(payment.useq, 2)}`

  return (
    <div className="split">
      <section className="info">
        <label className="field">
          <strong>入賬公司</strong>
          <span>{ Util.getCompanyName(payment.company) }</span>
        </label>
        <label className="field">
          <strong>顧客名稱</strong>
          <span>{ payment.cust_name }</span>
        </label>
        <label className="field">
          <strong>金額</strong>
          <span>${ Util.nf2(payment.amount) }</span>
        </label>
        <label className="field">
          <strong>支付類型</strong>
          <select value={payment_type} onChange={e=>setPayType(e.target.value)}>
            <option value="C">C - 現金</option>
            <option value="T">T - 轉賬</option>
            <option value="Q">Q - 支票</option>
            <option value="A">A - 調整</option>
            <option value="Z">Z - 賠償</option>
            <option value="X">X - 壞賬</option>
          </select>
        </label>
        <label className="field">
          <strong>入賬日期</strong>
          <DatePicker selected={transfer_dtm} dateFormat="yyyy-MM-dd"
            onChange={setTransferDate}
          />
        </label>
        <label className="field">
          <strong>參考編號</strong>
          <input value={ ref_code } onChange={e=>setRefCode(e.target.value) } />
        </label>
        <label className="field">
          <strong>收費月份</strong>
          <div>
            { payment.pay_month?.map(p =>
              <div key={p.l}>{p.l}: {p.n} 至 {p.x}</div>
            )}
          </div>
        </label>
        <label className="field">
          <strong>備註</strong>
          <textarea value={ remarks }
            onChange={e=>setRemarks(e.target.value)} />
        </label>
        <label className="field">
          <strong>不列印收據</strong>
          <input type="checkbox" checked={is_skipreceipt}
            onChange={e=>setIsSkipReceipt(e.target.checked)} />
        </label>
        <label className="field">
          <strong>建立</strong>
          <span>{ Util.FullDate(payment.create_dtm) } ({ payment.create_by })</span>
        </label>
        <label className="field">
          <strong>上次修改</strong>
          <span>{ Util.FullDate(payment.mod_dtm) } ({ payment.mod_by })</span>
        </label>
        <Protected allow={['ADMIN','OPERATOR']}>
          <div className="action-panel">
            <button className="btn blue" disabled={is_loading}
              onClick={updatePayment}>更改</button>
            <button className="btn red" disabled={is_loading}
              onClick={cancelPayment}>撤銷</button>
          </div>
        </Protected>
      </section>
      <section className="image">
        { !img_src
          ?<Loading />
          :<figure>
            <svg xmlns="http://www.w3.org/2000/svg"
              viewBox={`0 0 ${img_width} ${img_height}`}
              preserveAspectRatio="xMidYMid meet">
              <image href={img_src }
                  width={img_width}
                  height={img_height} />
            </svg>
            <figcaption alt={payment_id}>{payment_id}</figcaption>
          </figure>
        }
      </section>
    </div>
  );
};

export default PaymentCard
